<template>
  <div class="news-list-content">
    <a :href="data.url" target="_blank">
      <div class="news-list-item">
        <img  class="img" src="../../assets/img/time1.svg" alt="">
        <div class="date">{{data.date}}</div>
        <div class="title">{{data.title}}</div>
        <div class="company-name">{{data.company}}</div>
        <div class="risk" :class="data.sentiment">{{data.risk}}</div>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object
    }
  }
};
</script>

<style lang="scss" scoped>
.news-list-content {
  padding-left: 30px;
  background-color: #3e3c42;
  cursor: pointer;
  &:hover {
    background-color: #29272e;
  }
  .news-list-item {
    position: relative;
    padding: 18px 24px 24px 11px;
    border-left: 1px solid rgba(255, 255, 255, 0.1);
    font-size: 14px;
    .img {
      position: absolute;
      left: -8px;
      top: 19px;
      width: 14px;
      height: 14px;
    }
    .date {
      font-size: 12px;
      color: #ffffff99;
    }
    .title {
      padding: 8px 0;
      color: #ffffff;
      font-size: 16px;
    }
    .company-name {
      display: inline-block;
      margin-right: 8px;
      color: #ffffff;
      opacity: 0.8;
    }
    .risk {
      display: inline-block;
      color: #54cea4;
      opacity: 0.8;
    }
    .positive {
      color: #fe4954;
    }
    .negative {
      color: #54ce96;
    }
    .neutral, .all {
      color: #5ac8ff;
    }
  }
  a {
    text-decoration: none;
  }
}
</style>



